import { Controller } from "@hotwired/stimulus"
import '../../_jquery';
import 'slick-carousel/slick/slick.min';

export default class extends Controller {
  static targets = ['slider']

  connect() {
    this.initialize_slick_carousel()
  }

  initialize_slick_carousel() {
    if (!this.hasSliderTarget){
      // Lo slider è definito solo nel partial mobile e non in quello desktop,
      // anche se il controller è agganciato ad entrambi i componenti che,
      // ricordo, sono entrambi presenti in pagina contemporaneamente.
      return undefined;
    }

    let $that = $(this.sliderTarget);

    $that.slick({
      adaptiveHeight: true,
      mobileFirst: true,
      arrows: false,
      dots: true
    });

  }
}
